import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	followUpUserQuery: {
		id: 'issue-smart-request-summary.follow-ups.follow-up-user-query',
		defaultMessage: 'Summarize this {link}',
		description:
			'When user decides to continue conversation after summarizing the issue, this message will be shown in the chatbox as the original prompt that user sent',
	},
});
